import React, {useContext} from 'react';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {Button} from "elements/button/Button";

export const CARD_STATUS_POPUP = 'CARD_STATUS_POPUP';

export const CardStatus = ({currentCard, onCancelClick, onOverlayClick, onDoneClick}) => {
	const translations = useContext(TranslationsContext);

	return (<DrawerPopup
		title={getSafeTranslation('CardStatusPopup.title', translations)}
		description={getSafeTranslation('CardStatusPopup.description', translations).replace('{cardNumber}', currentCard)}
		onOverlayClick={onOverlayClick}
		leftControl={
			<Button isText onClick={onCancelClick}>{
				getSafeTranslation('CardStatusPopup.cancelButtonCaption', translations)
			}</Button>
		}
		rightControl={
			<Button isAutoWidth onClick={onDoneClick}>{
				getSafeTranslation('CardStatusPopup.doneButtonCaption', translations)
			}</Button>
		}
	>
	</DrawerPopup>)
}
